import { render, staticRenderFns } from "./SupportRequest.vue?vue&type=template&id=e7a2f8fe&"
import script from "./SupportRequest.vue?vue&type=script&lang=js&"
export * from "./SupportRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports